import { render, staticRenderFns } from "./ShapesSettings.vue?vue&type=template&id=991de40a&scoped=true&"
import script from "./ShapesSettings.vue?vue&type=script&lang=js&"
export * from "./ShapesSettings.vue?vue&type=script&lang=js&"
import style0 from "./ShapesSettings.vue?vue&type=style&index=0&id=991de40a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991de40a",
  null
  
)

export default component.exports